import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Navbar from "./nav_bar/Navbar";
import HeroSection from "./hero_section/HeroSection";
import FeaturesSection from "./FeaturesSection";
import HowDoesItWork from "./HowDoesItWork";
import GettingStarted from "./GettingStarted";
import TimeTable from "./time_table/TimeTable";
import CookieBanner from "./CookieBanner";
import Footer from "./footer/Footer";
import TestimonialsSection from "./TestimonialsSection";
import AnnouncementBar from "../announcement/AnnouncementBar";
import WordOfDayBanner from "./home/WordOfDayBanner";
import FloatingWhatsAppButton from "./FloatingWhatsAppButton";
import MobileNumberPrompt from "./home/MobileNumberPrompt";
import WebImagesSection from "./home/WebImagesSection";

const Divider = () => (
  <div style={{ width: "100%", padding: "0 40px", boxSizing: "border-box" }}>
    <div style={{
      height: "2px",
      background: "linear-gradient(90deg, transparent, #00a8cc, #019095, #00a8cc, transparent)",
      borderRadius: "999px",
    }} />
  </div>
);

const Homepage = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollToHowItWorks) {
      const section = document.getElementById("how-it-works");
      if (section) section.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);

  return (
    <>
      <Navbar />
      <AnnouncementBar />
      <MobileNumberPrompt />
      <WordOfDayBanner />
      <HeroSection />
      <WebImagesSection category="BANNER" />
      <Divider />
      <TimeTable />
      <Divider />
      <TestimonialsSection />
      <Divider />
      <FeaturesSection />
      <Divider />
      <HowDoesItWork />
      <Divider />
      <GettingStarted />
      <CookieBanner />
      <Footer />
      <FloatingWhatsAppButton />
    </>
  );
};

export default Homepage;
